import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({
    simple = false,
    useBr = false,
    disabled = false,
    readonly = false,
    ...args
  }) {
    super(args)
    const child = this.getComponentWithVModel('wysiwyg-input')
    this.children = [child]
    child.attrs = {
      ...child.attrs,
      simple,
      useBr,
      disabled,
      readonly
    }
  }
}
